export default __webpack_public_path__ + "static/media/3_3.61ec9bf2.png";